import { Map } from 'immutable'
import { MESSAGES_TYPES, MESSAGE_SENDER } from 'widget/constants'

import Carousel from 'widget/components/Carousel'
import QuickButton from 'widget/components/QuickButtons/Button'
import Message from 'widget/components/Messages/Message'

export function createNewMessage(text, sender, timestamp, isLiveAgent = false) {
  return Map({
    type: MESSAGES_TYPES.TEXT,
    component: Message,
    isLiveAgent,
    text,
    sender,
    showAvatar: true,
    timestamp
  })
}


export function createComponentMessage(component, props, showAvatar) {
  return Map({
    type: MESSAGES_TYPES.CUSTOM_COMPONENT,
    component,
    props,
    sender: MESSAGE_SENDER.BOT,
    showAvatar
  })
}

export function createQuickButton(button) {
  return Map({
    component: QuickButton,
    ...button
  })
}

export function createCarousel(carousel) {
  return Map({
    type: MESSAGES_TYPES.CAROUSEL,
    component: Carousel,
    slides: carousel.slides,
    sender: MESSAGE_SENDER.BOT,
    showAvatar: false
  })
}



// WEBPACK FOOTER //
// ./src/ChatWidget/store/reducers/helper.js